import { useRef } from "react";

export const useDebouncedFunction = <TFunc>(
  fn: TFunc,
  timeout: number = 1000
) => {
  const to = useRef<ReturnType<typeof setTimeout> | null>(null);

  return ((...args: any) => {
    if (to.current) {
      clearTimeout(to.current);
    }
    to.current = setTimeout(() => (fn as any)(...args), timeout);
  }) as TFunc;
};
